import 'reflect-metadata';
import { createElement, Fragment } from 'react';
import HTML5Backend from 'react-dnd-html5-backend';
import { DragDropContext } from 'react-dnd';
import { TopMenuBar, LeftMenuBar, LeftPanel, WorkArea } from './layout';
import withStyles, { WithStyles } from 'react-jss';
import { flowRight } from 'lodash';
import { observer } from 'mobx-react';
import './styles/styles.scss';
import { store } from './store';
import DialogElement from './layout/DialogElement';

require('./components');

const styles = {
    wrapper: {
        display: 'flex',
        flexDirection: 'column',
        height: '100vh',
        width: '100vw',
        left: 0,
        top: 0,
        position: 'absolute',
        zIndex: 99999,
    },
    stage: {
        display: 'flex',
        flexDirection: 'row',
        flexGrow: 1,
        maxWidth: '100vw',
        overflow: 'hidden',
        '&>div': {
            // outline: '1px solid black',
        },
    },
};

interface IProps extends WithStyles<typeof styles> {}

const App: React.FunctionComponent<IProps> = ({ classes }) => (
    <div className={classes.wrapper}>
        <TopMenuBar />
        <div className={classes.stage}>
            {store.isSettingsOpen ? (
                <LeftPanel />
            ) : (
                <Fragment>
                    <LeftMenuBar />
                    <LeftPanel />
                </Fragment>
            )}
            <WorkArea />
        </div>
        <DialogElement />
    </div>
);

(window as any).store = store;

export default flowRight([DragDropContext(HTML5Backend), withStyles(styles), observer])(App);
